import React from "react";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";

function FormAutocompleteMulti({
  key,
  name,
  label,
  values,
  defaultValue,
  control,
  sxValues,
  freeSolo = false,
  helperText,
  rules,
  filterOptions,
  isOptionEqualToValue = () => {},
  onValueSelected = (value) => {},
  inputProps,
  ...rest
}) {
  const getOptionLabel = (option) => (typeof option === "string" ? option : option?.label || "");
  const getOptionKey = (option) => option?.jp_id ?? option?.id ?? getOptionLabel(option);

  let preloadedValue = [];
  if (defaultValue) {
    if (typeof defaultValue === "string") {
      const splitVal = defaultValue.split("| ").map((s) => s.trim());

      preloadedValue = splitVal.map((selected) => {
        return (
          values.find(
            (defaultOption) =>
              getOptionLabel(defaultOption).toLowerCase() === selected.toLowerCase()
          ) || selected
        );
      });
    } else {
      preloadedValue = defaultValue;
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={preloadedValue || []}
      rules={rules || (helperText ? { required: helperText } : undefined)}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          multiple
          freeSolo={freeSolo}
          key={key}
          fullWidth
          value={value || []}
          onChange={(e, newValue) => {
            const uniqueValues = Array.from(
              new Map(newValue.map((v) => [getOptionKey(v), v])).values()
            );
            onChange(uniqueValues);
            onValueSelected(uniqueValues);
          }}
          options={values || []}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          filterSelectedOptions
          filterOptions={(options, params) => {
            // Apply custom filterOptions if provided
            if (filterOptions) {
              return filterOptions(options, params);
            }

            // Default filtering with case-insensitive deduplication
            const filtered = options.filter((option) =>
              getOptionLabel(option).toLowerCase().includes(params.inputValue.toLowerCase())
            );

            return Array.from(
              new Map(filtered.map((item) => [getOptionKey(item), item])).values()
            );
          }}
          renderInput={(params) => (
            <TextField
              error={!!error}
              helperText={error ? error.message : null}
              {...params}
              {...rest}
              sx={sxValues}
              label={label}
              InputProps={{
                ...params.InputProps,
                ...inputProps,
                startAdornment: (
                  <>
                    {inputProps?.startAdornment}
                    {params.InputProps.startAdornment}
                  </>
                )
              }}
            />
          )}
        />
      )}
    />
  );
}

export default FormAutocompleteMulti;
